




























































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import BankStatementApi from "../services/BankStatementApi";
import PartBankApi from "@/modules/partBank/services/partBankApi";
import PartBank from "@/modules/cashPoint/models/PartBank";
import { StockFinancingCreatedStatement } from "../models/StockFinancingImportResult";
import { t } from "@/plugins/i18n";

interface Data {
  technicalBanks: PartBank[];
  selectedPartBank: number;
  file: File | null;
  setPaid: boolean;
  importInProgress: boolean;
  exceptions: string[];
  warnings: string[];
  createdStatements: StockFinancingCreatedStatement[];
}

export default Vue.extend({
  data: (): Data => ({
    technicalBanks: [],
    selectedPartBank: 0,
    file: null,
    setPaid: true,
    importInProgress: false,
    exceptions: [],
    warnings: [],
    createdStatements: [],
  }),

  async beforeMount() {
    const banks = await PartBankApi.getMyOwnPartBanks();
    this.technicalBanks = banks.filter((b) => b.technical && !b.deleted);
    this.technicalBanks.forEach((b) => {
      b.displayName = `${b.id} – ${b.accountNo} (${b.bank}, ${b.currency})`;
    });
  },

  methods: {
    async importFile() {
      if (this.importInProgress) {
        return;
      }
      this.importInProgress = true;
      this.exceptions = [];
      this.warnings = [];
      this.createdStatements = [];

      try {
        const result = await BankStatementApi.importStockFinancing(
          this.file as File,
          this.selectedPartBank,
          this.setPaid
        );
        this.exceptions = result.exceptions ?? [];
        this.warnings = result.warnings ?? [];
        this.createdStatements = result.createdStatements ?? [];

        if (this.exceptions.length === 0) {
          eventBus.$emit(
            "success",
            this.setPaid
              ? t("BankStatement_AKeszletfinanszirozasImportSikeresenLefutott")
              : t("BankStatement_AKeszletfinanszirozasImportLefutottATeteleket")
          );
        }
      } finally {
        this.importInProgress = false;
      }
    },

    formatDate(date: string): string {
      return new Date(date).toLocaleDateString("hu-HU");
    },

    cancel() {
      this.$router.push("/bank-statements");
    },
  },

  computed: {
    canImport(): boolean {
      return !!this.file && this.selectedPartBank > 0 && !this.importInProgress;
    },
  },
});
